import { useTranslation } from 'react-i18next';
import { Loader } from '@mantine/core';
import PageHeader from '@/components/page-header';
import SettingsLayout from '@/components/settings-layout';
import LanguageSelector from '@/components/language-selector';
import { localUser, updateMe } from '@/services/session-service';
import { setWebTitle } from '@/lib/format-utils';
import { useUpdateUser } from '@/hooks/api-hooks';
import { notify } from '@/lib/notify';


export default function SettingsLanguagePage(): JSX.Element {
    const { t } = useTranslation();
    const user = localUser();
    const updateUserMutation = useUpdateUser();

    const save = (newLanguage: string) => {
        if (!user) return;

        updateUserMutation.mutate({
            id: user.id,
            language: newLanguage
        }, {
            onSuccess: async () => {
                await updateMe(true);
                window.location.reload();
            },
            onError: () => {
                notify.error(t('error_updating_language'), t('error'));
            }
        });
    };

    setWebTitle(t('language'));

    return (
        <div>
            <PageHeader title={t('settings')} />

            <div className="panel-content">
                <SettingsLayout>
                    <div className='font-semibold text-gray-800 text-2xl mb-2'>
                        {t('language')}
                    </div>
                    <div className='text-gray-700 text-sm mb-6'>
                        {t('language_description')}
                    </div>
                    <div className="solid-box-border w-fit">
                        <LanguageSelector
                            className='w-fit'
                            value={user?.language}
                            rightSection={updateUserMutation.isPending ? <Loader size="xs" /> : null}
                            onChange={(value) => save(value)}
                        />
                    </div>
                </SettingsLayout>
            </div>
        </div>
    );
}
